// @flow

export function validateCardHolderName(cardHolderName: string): boolean {
  return /^\D+$/.test(cardHolderName);
}
